import { alpha } from '@mui/material/styles';
import { palette } from '../global/palette';
import type { ComponentOverride } from '../types';

export const MuiBackdrop: ComponentOverride<'MuiBackdrop'> = {
  MuiBackdrop: {
    styleOverrides: {
      root: {
        backgroundColor: `${alpha(palette.common.black, 0.3)} !important`,
      },
    },
  },
};
